import { getItem } from '../utils/StorageManager'

// object está vazio?
export function isEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false
    }
  }

  return JSON.stringify(obj) === JSON.stringify({})
}

// TODO solucão paliativa
export function getOrganizationCurrent() {
  const token = getItem('accessToken')
  const organizationToken = token.split('.')[1]
  const organizationData = JSON.parse(window.atob(organizationToken))
  return organizationData.organizationId
}
